import { getRandomIntInclusive } from '@application/utils';
import { CardItem, SkeletonBox } from '@presentation/components';
import { ContentTitle } from '@presentation/components/CardItem/styled';
import { useMemo } from 'react';
import * as Styled from '../styled';

export const Skeleton = () => {
  const skeletons = useMemo(() => {
    return {
      title: { width: getRandomIntInclusive(150, 220), height: 21.5 },
      infos: Array(3)
        .fill(undefined)
        .map(() => ({
          label: { width: getRandomIntInclusive(40, 70), height: 20 },
          value: { width: getRandomIntInclusive(40, 60), height: 20 },
        })),
      footerText: { width: 80, height: 19 },
    };
  }, []);

  return (
    <CardItem loading footer={<SkeletonBox style={{ ...skeletons.footerText }} />}>
      <ContentTitle>
        <SkeletonBox style={{ ...skeletons.title }} />
      </ContentTitle>
      <Styled.Container>
        {skeletons.infos.map((info, index) => (
          <Styled.Wrapper key={index}>
            <Styled.Label>
              <SkeletonBox style={{ ...info.label }} />
            </Styled.Label>
            <Styled.Value>
              <SkeletonBox style={{ ...info.value }} />
            </Styled.Value>
          </Styled.Wrapper>
        ))}
      </Styled.Container>
    </CardItem>
  );
};
